import Header3 from '../components/Header3';
import Footer3 from '../components/Footer3';
import { Helmet } from 'react-helmet';
import InnovationContent from '../components/BannerBlocks/InnovationContent';

function Innovation() {
    return (
        <>
            <Helmet>
                <title>{`Testfabrics.com: Innovation`}</title>
            </Helmet>
            <Header3 />
            <InnovationContent/>
            <Footer3 />
        </>
    );
}

export default Innovation;
